import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Megaphone, Copy, ExternalLink, Code2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const slugify = (s) =>
  (s || "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export function CampaignLinkCard() {
  const [campaign, setCampaign] = useState("");
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  const { directLink, embedCode } = useMemo(() => {
    const slug = slugify(campaign);
    const q = slug ? `?utm_campaign=${slug}` : "";
    const direct = `${origin}/calculator${q}`;
    const embedSrc = `${origin}/calculator?embed=1${slug ? `&utm_campaign=${slug}` : ""}`;
    const embed = `<iframe src="${embedSrc}" width="100%" height="760" style="border:0;border-radius:16px" title="Rimpatrio24"></iframe>`;
    return { directLink: direct, embedCode: embed };
  }, [campaign, origin]);

  const copy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => toast.success(`${label} copiato`)).catch(() => toast.error("Errore copia"));
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm" data-testid="campaign-link-card">
      <div className="flex items-center gap-2 mb-1">
        <span className="h-9 w-9 rounded-lg bg-amber-50 text-amber-700 flex items-center justify-center"><Megaphone size={17} strokeWidth={1.5} /></span>
        <div>
          <h3 className="font-display text-lg font-semibold text-slate-900 leading-none">Link calcolatore per campagne</h3>
          <p className="text-xs text-slate-400 mt-1">Genera un link diretto o un codice da incorporare su altri siti.</p>
        </div>
      </div>

      <div className="mt-4 space-y-4">
        <div className="space-y-1.5 max-w-xs">
          <Label>Nome campagna (opzionale)</Label>
          <Input value={campaign} onChange={(e) => setCampaign(e.target.value)} placeholder="es. facebook-giugno" data-testid="campaign-name-input" />
        </div>

        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-400">Link diretto</Label>
          <div className="flex gap-2">
            <Input readOnly value={directLink} className="font-mono text-xs bg-slate-50" data-testid="campaign-direct-link" onFocus={(e) => e.target.select()} />
            <Button variant="outline" size="icon" onClick={() => copy(directLink, "Link")} data-testid="campaign-copy-link"><Copy size={15} /></Button>
            <a href={directLink} target="_blank" rel="noreferrer"><Button variant="outline" size="icon" data-testid="campaign-open-link"><ExternalLink size={15} /></Button></a>
          </div>
        </div>

        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-400 flex items-center gap-1"><Code2 size={13} /> Codice iframe (da incorporare)</Label>
          <div className="flex gap-2 items-start">
            <textarea readOnly value={embedCode} rows={3}
              className="flex-1 font-mono text-xs bg-slate-50 border border-slate-200 rounded-md p-2.5 resize-none text-slate-600"
              data-testid="campaign-embed-code" onFocus={(e) => e.target.select()} />
            <Button variant="outline" size="icon" onClick={() => copy(embedCode, "Codice")} data-testid="campaign-copy-embed"><Copy size={15} /></Button>
          </div>
        </div>
      </div>
    </div>
  );
}
